const SDK_URL = 'https://cdn.dojo.tech/payments/v1/client.js';
let loading = null;

export function loadDojoSDK() {
  if (window.Dojo?.Payment) return Promise.resolve(window.Dojo);
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = SDK_URL;
    s.async = true;
    s.onload = () => (window.Dojo?.Payment
      ? resolve(window.Dojo)
      : (loading = null, s.remove(), reject(new Error('Dojo SDK loaded but Dojo.Payment not defined'))));
    s.onerror = () => { loading = null; s.remove(); reject(new Error('Card payment form failed to load')); };
    document.head.appendChild(s);
  });
  return loading;
}
